import { ChakraProps } from '@aloft/toolkit-sui/chakra';

import { isLastPinned } from './isLastPinned.ts';

export function getPinnedCellStyles(
  shouldPinFirstRow: boolean | number,
  rowIndex: number,
): ChakraProps {
  return isLastPinned(shouldPinFirstRow, rowIndex) ? { borderBottomWidth: '2px' } : {};
}
